<template>
    <div v-if="album">
        <Header/>
        <div id="content" class="-album">
            <div class="container">
                <photos/>
            </div>
            <powered-by v-if="hasPoweredBy"/>
        </div>
        <vue-headful :title="headTitle(album.title)"/>
        <back-button v-if="!orderStep" :url="prevUrl"/>
        <div v-if="!isMobile" :class="['album-action', 'album-action--wrap', {'album-action-fullscreen-header': album.header_type === 'fullscreen'}]">
            <!--<button v-if="photos" class="btn btn-icon-left btn-success text-uppercase">&lt;!&ndash;@click="orderAllPhotos"&ndash;&gt;
                <span class="material-icon icon-add">
                {{ $t('order_all_photos') }}
            </button>-->
            <button v-if="favoritesLength && products && products.length > 0" @click="orderFavoritePhotos" id="order-selected-btn" class="btn btn-icon-left btn-success text-uppercase mr-3">
                <span class="material-icon icon-library_add"/>
                {{ $tc('order_n_selected_photos', favoritesLength, {amount: favoritesLength}) }}
            </button>
            <form v-if="+album.free_download" :action="`${apiUrl}v2/albums/${downloadUrl}`" method="post" target="_blank">
                <input v-if="privateTags" type="hidden" name="X-bk-tags" :value="privateTags">
                <button id="download-album-btn" class="btn btn-icon-left btn-light text-uppercase">
                    <span class="material-icon icon-cloud_download"/>
                    {{ $t('download_album') }}
                </button>
            </form>
        </div>
    </div>
    <div v-else-if="errorMessage" id="content" class="-error">
        <div class="container">
            <div class="alert alert-danger">{{ errorMessage }}</div>
        </div>
    </div>
</template>

<style lang="scss">
    .-album {
        .tags,
        .sorting {
            margin-top: 0 !important;
        }
    }
</style>

<style lang="scss" scoped>
    #content:not(.-error) {
        padding: 30px 0 100px !important;
    }

    .album-actions {
        position: fixed;
        display: flex;
        right: 0;
        bottom: 0;
        z-index: 9999;
    }
</style>

<script>
  import Header from './album/Header.vue';
  import Photos from './album/Photos.vue';
  import PoweredBy from './PoweredBy.vue';
  import BackButton from './BackButton.vue';

  import album from 'src/mixins/albumComponent';

  export default {
    mixins: [album],
    components: {
      Header,
      Photos,
      PoweredBy,
      BackButton,
    },
  };
</script>